import { useCallback } from "react";
import type { GridToolbarProps } from "@mui/x-data-grid-premium";
import AiHubTableToolbar from "../AiHubTableToolbar";
import { downloadTriageResultsCsv } from "./triageResultData";
import type { TriageResultRow } from "./types";

type TriageResultTableToolbarProps = GridToolbarProps & {
  exportRows?: TriageResultRow[];
};

export default function TriageResultTableToolbar({
  exportRows = [],
}: TriageResultTableToolbarProps) {
  const handleExport = useCallback(
    () => downloadTriageResultsCsv(exportRows),
    [exportRows],
  );

  return (
    <AiHubTableToolbar
      exportTooltip="Export filtered triage results."
      exportFailureMessage="Failed to export triage results."
      onExport={handleExport}
    />
  );
}
